// extracted by mini-css-extract-plugin
export var animationContainer = "_ee-0";
export var asteriskIcon = "_ee-8";
export var conversationLeftSection = "_ee-4";
export var conversationListItem = "_ee-3";
export var conversationMiddleSection = "_ee-5";
export var conversationRightSection = "_ee-6";
export var detailsContent = "_ee-1";
export var listContainer = "_ee-7";
export var modalContent = "_ee-2";